var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNews = function SvgNews(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 12,
    fill: "#E3ECFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1301_6994)",
    filter: "url(#filter0_d_1301_6994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5653 34.8711L22.7699 35.0837C22.1596 35.2461 21.5156 35.0111 21.1573 34.4957L17.7526 29.6404L23.476 30.2507L24.5623 32.8381C24.9093 33.6781 24.4446 34.6357 23.5653 34.8711ZM12.5166 19.5324L10.6686 20.0307C9.47032 20.3553 8.75326 21.5873 9.07832 22.7861L10.2486 27.1541C10.568 28.3524 11.8 29.0637 13.004 28.7387L14.852 28.2461L12.5166 19.5324ZM30.9328 28.3314L26.4024 11.4216C26.2664 10.9127 25.6622 10.6997 25.2369 11.0094L14.1384 19.1006L16.4725 27.8112L30.1295 29.2698C30.6528 29.3258 31.0693 28.8389 30.9328 28.3314ZM31.6201 14.3287C31.4923 14.3287 31.3641 14.2964 31.246 14.2281C30.8873 14.0212 30.7648 13.5627 30.9717 13.2044L32.0554 11.3279C32.2619 10.9687 32.7217 10.8462 33.0791 11.0536C33.4379 11.2606 33.5604 11.7191 33.3534 12.0774L32.2698 13.9538C32.1306 14.1944 31.8786 14.3287 31.6201 14.3287ZM32.6902 19.5477C32.359 19.5477 32.0563 19.3267 31.9666 18.9921C31.8598 18.5922 32.0969 18.1814 32.4968 18.0737L34.5898 17.5133C34.9919 17.4066 35.4009 17.6428 35.5086 18.0436C35.6153 18.4434 35.3782 18.8542 34.9783 18.9619L32.8853 19.5223C32.8193 19.5398 32.7545 19.5477 32.6902 19.5477ZM36.2497 25.6862C36.1219 25.6862 35.9938 25.6539 35.8756 25.5856L33.9992 24.5019C33.6404 24.295 33.5179 23.8365 33.7249 23.4782C33.9318 23.119 34.3912 22.9965 34.7486 23.2039L36.6251 24.2876C36.9838 24.4945 37.1063 24.953 36.8994 25.3113C36.7607 25.5519 36.5083 25.6862 36.2497 25.6862Z",
    fill: "#799EEC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1301_6994",
    x: 3,
    y: 4,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.1125 0 0 0 0 0.36587 0 0 0 0 0.9 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1301_6994"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1301_6994",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1301_6994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(9 9)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNews);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/news.469c071ea8757194989fbf194c52432d.svg";